import ClearIcon from "@mui/icons-material/Clear";
import { DialogTitle, Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { CloseButton, SubTitle } from "../styles";

interface ModalTitleProps {
  title: string;
  subtitle?: string[];
  onClose?: () => void;
  children?: ReactNode;
}
const ModalTitle = ({ title, subtitle, onClose, children, ...props }: ModalTitleProps) => {
  return (
    <DialogTitle aria-labelledby="customized-modal-title" component={Stack} sx={{ p: 0, py: 2, px: 3 }} {...props}>
      <Stack
        direction="row"
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h4" noWrap>
          {title}
        </Typography>

        {onClose && (
          <CloseButton aria-label="close" onClick={onClose} size="large">
            <ClearIcon />
          </CloseButton>
        )}
      </Stack>
      <Stack>
        {Array.isArray(subtitle) ? (
          subtitle.map((sub, index) => (
            <Stack key={index}>
              {index === 0 && <SubTitle>{sub}</SubTitle>}
              {index !== 0 && <Typography>{sub}</Typography>}
            </Stack>
          ))
        ) : typeof subtitle === "string" ? (
          <Stack>
            <SubTitle variant="body1">{subtitle}</SubTitle>
          </Stack>
        ) : null}
      </Stack>
      {children}
    </DialogTitle>
  );
};
export default ModalTitle;
